import type { QueryClient } from "@tanstack/react-query";
import { authMutations } from "./auth";
import { bulletinMutations } from "./bulletin";
import { caseMutations } from "./case";
import { channelMutations } from "./channel";
import { groupMutations } from "./group";
import { hemiMutations } from "./hemi";
import { memberMutations } from "./member";
import { messageMutations } from "./message";
import { patientMutations } from "./patient";
import { reminderMutations } from "./reminder";
import { storageMutations } from "./storage";
import { registerTeamMutations } from "./team";
import { verifyMutations } from "./verification";

export default function registerDefaultMutations(queryClient: QueryClient) {
	authMutations(queryClient);
	memberMutations(queryClient);
	verifyMutations(queryClient);
	groupMutations(queryClient);
	storageMutations(queryClient);
	messageMutations(queryClient);
	channelMutations(queryClient);
	reminderMutations(queryClient);
	caseMutations(queryClient);
	patientMutations(queryClient);
	bulletinMutations(queryClient);
	hemiMutations(queryClient);
	registerTeamMutations(queryClient);
}
